(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CallType', CallType);

    CallType.$inject = ['$resource'];

    function CallType ($resource) {
        var resourceUrl =  'api/call-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
